import React from 'react';
import styled from 'styled-components';

import { retinaBackgroundImage } from 'utils/style';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  width: 100%;
`;
const LoadingImage = styled.div`
  ${retinaBackgroundImage('/static/images/loading.png', {
    include3x: false,
  })};
  background-size: contain;
  width: 50px;
  height: 50px;
  animation-name: rotate;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const LoadingIndicator = () => (
  <Container>
    <LoadingImage />
  </Container>
);

// eslint-disable-next-line import/no-default-export
export default LoadingIndicator;
